'use client';

import { styled } from '@mui/material/styles';

import type { LinkProps } from '@mui/material';

export interface RootLinkStyleProps extends LinkProps {
  open?: boolean;
  active?: boolean;
  scrolling?: boolean;
  transparent?: boolean;
}

/**
 * @deprecated - use ActiveLink instead
 */
export const RootLinkStyle = styled( 'a', {
  shouldForwardProp: (prop) =>
    prop !== 'active'
    && prop !== 'scrolling'
    && prop !== 'transparent'
    && prop !== 'open',
} )<RootLinkStyleProps>( ({ active, scrolling, transparent, open, theme }) => {
  const dotActiveStyle = {
    '&:before': {
      top: 0,
      width: 6,
      height: 6,
      bottom: 0,
      left: -14,
      content: '""',
      display: 'block',
      margin: 'auto 0',
      borderRadius: '50%',
      position: 'absolute',
      backgroundColor: theme.palette.primary.main,
    },
  };

  return {
    ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    color: theme.palette.text.primary,
    position: 'relative',
    alignItems: 'center',
    transition: theme.transitions.create( 'opacity', {
      duration: theme.transitions.duration.shortest,
    } ),
    '&:hover': {
      opacity: 0.72,
      textDecoration: 'none',
    },
    ...(active && {
      ...dotActiveStyle,
      color: theme.palette.text.primary,
      ...(transparent && { color: theme.palette.common.white }),
      ...(scrolling && { color: theme.palette.text.primary }),
    }),
    ...(open && { color: theme.palette.primary.main }),
  };
} );
